import './styles.scss'
import { t } from 'i18next'
import React from 'react'
import { COFFEE_PEDIA } from 'Utils/Constants'
import MetaTagsComponent from 'Components/MetaTagsComponent'

const CoffeePedia = () => (
  <>
    <MetaTagsComponent title={t('COFFEE_WIKI_TITLES')} description={t('COFFEE_WIKI_DESCRIPTION')} keywords={t('COFFEE_WIKI_KEYWORDS')} url="https://coffeeweb.com/coffeeweb" h1Content={t('COFFEE_WIKI_H1_CONTENT')} />

    <div className="coffeepedia-container">
      <video controls className="coffeepedia-video" autoPlay loop playsInline>
        <source src={COFFEE_PEDIA.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </>
)

export default CoffeePedia
